import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { Version } from 'types';

type UpdateVersionData = {
  name?: string;
  description?: string;
  startDate?: string;
  releaseDate?: string;
  released?: boolean;
  archived?: boolean;
};

const updateVersion = async (
  versionId: string,
  updateData: UpdateVersionData
): Promise<Version> => {
  const response = await customAxios.patch<Version>(`/versions/${versionId}`, updateData);
  return response.data;
};

export const useUpdateVersion = (orgId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      versionId,
      updateData,
    }: {
      versionId: string;
      updateData: UpdateVersionData;
    }) => updateVersion(versionId, updateData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['versions', orgId] }).catch(() => undefined);
    },
  });
};
